import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = (props) => {
    const location = useLocation();
    
    useEffect(() => {
      // Scroll to top on route change (but not on hash changes within same page)
      if (!location.hash) {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
      }
    }, [location.pathname, location.hash]);
  
    return <>
        {props.children}
    </>
  };

export default ScrollToTop;
